/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Create_Contact_ColorInputs */

const en_forms_rule_sets_create_contact_color = /** @type {(inputs: Forms_Rule_Sets_Create_Contact_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Color`)
};

const de_forms_rule_sets_create_contact_color = /** @type {(inputs: Forms_Rule_Sets_Create_Contact_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Contact Color" |
*
* @param {Forms_Rule_Sets_Create_Contact_ColorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_create_contact_color = /** @type {((inputs?: Forms_Rule_Sets_Create_Contact_ColorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Create_Contact_ColorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_create_contact_color(inputs)
	return de_forms_rule_sets_create_contact_color(inputs)
});